import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";

import CommonCard from "components-v2/kpi/common-card";

import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function TeamUtilizationCard({ onClick, cardData, tagId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["team-utilization", tagId],
    queryFn: async () => {
      const response = await apiRoot.get("kpi/team-utilization", {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
  });

  const utilization = data?.utilization ?? 0;
  const totalLogged = data?.totalLoggedHours ?? 0;
  const availableHours = data?.availableHours ?? 0;



  const { title, description } = HOME_CARD_CONTENT.teamUtilization;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : utilization,
        unit: "%",
        details: [
          { label: "Logged Hours", value: `${totalLogged}h` },
          { label: "Available Hours", value: `${availableHours}h` }
        ],
      }}
      percentage={utilization}
      isLoading={isLoading}

    />
  );
}
